function initSelleasyMetafield() {
  const containers = document.querySelectorAll("[data-selleasy]")
  if (!containers.length) return

  async function addToCart(items) {
    const res = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        items,
        sections: ["cart-drawer", "cart-icon-bubble"],
        sections_url: window.location.pathname,
      }),
    })

    if (!res.ok) {
      const error = await res.json().catch(() => ({}))
      throw new Error(error.description || "Unable to add item to cart")
    }

    return res.json()
  }

  // Preorder: toggle the alert and keep the date on the add button
  function updatePreorder(item, variant) {
    const btn = item.querySelector("[data-selleasy-add]")
    const wrapper = item.querySelector("[data-selleasy-preorder]")
    const date = variant?.preorder || ""

    if (btn) btn.dataset.preorder = date

    if (wrapper) {
      if (date) wrapper.textContent = `This item is on preorder and will ship from ${date}.`
      wrapper.hidden = !date
    }
  }

  function updateItem(item) {
    const btn = item.querySelector("[data-selleasy-add]")
    if (!btn) return

    const variants = JSON.parse(item.dataset.selleasyVariants || "[]")
    const selects = [...item.querySelectorAll("[data-selleasy-option-select]")]
      .sort((a, b) => Number(a.dataset.selleasyOptionSelect) - Number(b.dataset.selleasyOptionSelect))
    const selected = selects.map(s => s.value)

    const match = variants.find(v =>
      v.available &&
      (selects.length < 1 || v.option1 === selected[0]) &&
      (selects.length < 2 || v.option2 === selected[1]) &&
      (selects.length < 3 || v.option3 === selected[2])
    )

    const img = item.querySelector(".selleasy-row__image img")

    updatePreorder(item, match)

    if (match) {
      btn.dataset.variantId = String(match.id)
      btn.disabled = false
      if (img) img.src = match.image || img.dataset.defaultSrc
    } else {
      btn.dataset.variantId = ""
      btn.disabled = true
      if (img) img.src = img.dataset.defaultSrc
    }
  }

  containers.forEach(container => {
    container.querySelectorAll("[data-selleasy-option-select]").forEach(select => {
      select.addEventListener("change", () => {
        const item = select.closest("[data-selleasy-item]")
        if (!item) return

        const variants = JSON.parse(item.dataset.selleasyVariants || "[]")
        const selects = [...item.querySelectorAll("[data-selleasy-option-select]")]
          .sort((a, b) => Number(a.dataset.selleasyOptionSelect) - Number(b.dataset.selleasyOptionSelect))

        const changedIndex = Number(select.dataset.selleasyOptionSelect)

        // For each select after the changed one, rebuild its options based on current selections
        selects.forEach((otherSelect, otherIdx) => {
          if (otherIdx <= changedIndex) return

          const filtered = variants.filter(v => {
            if (!v.available) return false
            for (let k = 0; k < otherIdx; k++) {
              if (v[`option${k + 1}`] !== selects[k].value) return false
            }
            return true
          })

          const optionKey = `option${otherIdx + 1}`
          const availableValues = [...new Set(filtered.map(v => v[optionKey]).filter(Boolean))]
          const prevValue = otherSelect.value

          otherSelect.replaceChildren(
            ...availableValues.map(val => new Option(val, val, false, val === prevValue))
          )

          if (!availableValues.includes(prevValue) && availableValues.length > 0) {
            otherSelect.value = availableValues[0]
          }
        })

        updateItem(item)
      })
    })

    container.querySelectorAll("[data-selleasy-add]").forEach(btn => {
      btn.addEventListener("click", async () => {
        const variantId = Number(btn.dataset.variantId)
        if (!variantId || btn.disabled) return

        btn.disabled = true

        const cartItem = { id: variantId, quantity: 1 }
        if (btn.dataset.preorder) {
          cartItem.properties = { Preorder: `Ships from ${btn.dataset.preorder}` }
        }

        try {
          const data = await addToCart([cartItem])

          const drawer = document.querySelector("cart-drawer")
          if (drawer?.renderContents) {
            drawer.renderContents(data)
            drawer.classList.remove("is-empty")
          } else {
            const notification = document.querySelector("cart-notification")
            if (notification?.open) {
              notification.open()
            } else {
              window.location.href = "/cart"
            }
          }
        } catch (err) {
          console.error(err)
        } finally {
          btn.disabled = false
        }
      })
    })

    // Scrollbar
    const list = container.querySelector(".selleasy__list")
    const thumb = container.querySelector(".selleasy__scrollbar-thumb")

    if (list && thumb) {
      function updateThumb() {
        const scrollable = list.scrollWidth - list.clientWidth
        const trackWidth = thumb.parentElement.clientWidth
        const thumbWidth = (list.clientWidth / list.scrollWidth) * trackWidth

        thumb.style.width = thumbWidth + "px"

        if (scrollable > 0) {
          const scrollRatio = list.scrollLeft / scrollable
          thumb.style.left = scrollRatio * (trackWidth - thumbWidth) + "px"
        } else {
          thumb.style.left = "0px"
        }

        // Hide scrollbar entirely if nothing to scroll
        thumb.parentElement.style.display = scrollable > 0 ? "block" : "none"
      }

      updateThumb()
      list.addEventListener("scroll", updateThumb)
      window.addEventListener("resize", updateThumb)
    }
  })
}

document.addEventListener("DOMContentLoaded", () => {
  initSelleasyMetafield()
})
